// Set REACT_APP_API_URL (e.g. http://localhost:8001/) to point a dev server at a local API
export const NAMEPSACE = process.env.REACT_APP_API_URL || 'https://kino-api.unruffled-nightingale.com/'

// Rating is unlocked by a secret path: /sesame lets you rate films and see ratings in the
// table, /opensesame also only plays films that haven't been rated yet. There's no router,
// so the path is fixed for the life of the page.
const path = window.location.pathname.replace(/\/+$/, '').toLowerCase()
export const IS_ADMIN = path === '/opensesame'
export const CAN_RATE = IS_ADMIN || path === '/sesame'
